import { Voter } from "@activecollab/security";
import { isPowerClient } from "~/utils/userHelper";

export class GhostTaskVoter extends Voter {
  attributes = ["edit"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "GhostTask";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "edit": {
        if (user.class === "Client") {
          return isPowerClient(user);
        }
        return true;
      }
    }

    throw new Error("This code should not be reached!");
  }
}
